import { render, staticRenderFns } from "./onlineReserRlue.vue?vue&type=template&id=a715d5ae&scoped=true"
import script from "./onlineReserRlue.vue?vue&type=script&lang=js"
export * from "./onlineReserRlue.vue?vue&type=script&lang=js"
import style0 from "./onlineReserRlue.vue?vue&type=style&index=0&id=a715d5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a715d5ae",
  null
  
)

export default component.exports